module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av544-b9c9502d610c364db40fe413e1245cf1.jpg";